/* eslint-disable react/require-default-props */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Chip, Typography } from '@material-ui/core';
import CustomCard from '../../../common/CustomCard';
import { useStudentNeedingSupportStyles } from './styles/AssignmentSectionStyles';


const StudentNeedingSupport = ({ studentData, onStudentClick }) => {
  const classes = useStudentNeedingSupportStyles();

  const chaptersRef = useRef(null);
  const isDown = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const handleMouseDown = (e) => {
    isDown.current = true;
    startX.current = e.pageX - chaptersRef.current.offsetLeft;
    scrollLeft.current = chaptersRef.current.scrollLeft;
  };

  const handleMouseLeave = () => {
    isDown.current = false;
  };

  const handleMouseUp = () => {
    isDown.current = false;
  };

  const handleMouseMove = (e) => {
    if (!isDown.current) return;
    e.preventDefault();
    const x = e.pageX - chaptersRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.5;
    chaptersRef.current.scrollLeft = scrollLeft.current - walk;
  };

  return (
    <Box className={classes.studentCardList}>
      {studentData.map((student, index) => (
        <Button
          key={index}
          onClick={() => onStudentClick(student)}
        >
          <CustomCard key={index} backgroundColor="#F6F6FB" style={{ minHeight: 0, width: '100%' }}>
            <Box className={classes.topRow}>
              <Typography variant="subtitle1" className={classes.nameText}>
                {student.name}
              </Typography>
            </Box>
            {student.topics.length > 0 && (
            <Box
              className={classes.chaptersWrapper}
              ref={chaptersRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
            >
              {student.topics.map((chapter, idx) => (
                <Chip className={classes.chip} key={idx} label={chapter} size="small" />
              ))}
            </Box>
            )}
          </CustomCard>
        </Button>
      ))}
    </Box>
  );
};

StudentNeedingSupport.propTypes = {
  studentData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      topics: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  ).isRequired,
  onStudentClick: PropTypes.func
};

export default StudentNeedingSupport;
